// extracted by mini-css-extract-plugin
export var sliderRange = "_dm-2";
export var sliderRoot = "_dm-0";
export var sliderThumb = "_dm-3";
export var sliderTrack = "_dm-1";